// ProductID
export const Product = {
    DB: 1,
    DC: 2,
    VB: 3
};